<app-tab-layout [loading]="loading()" [error]="error">
  @if (initialized()) {
    <app-api-table
      [name]="name"
      [endpoint]="endpoint()"
      [hasIndexCol]="true"
    ></app-api-table>
  }
</app-tab-layout>
